/**
 * Private Route Component
 * Guest-first: without a session the app still opens, in read-only
 * exploration mode (guest). API writes are blocked in config/api.js and
 * prompt for login instead, so nothing here needs to redirect.
 */
import React from 'react';
import authService from '../../services/authService';
import { setGuest } from '../../services/guestMode';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  setGuest(!isAuthenticated);
  return children;
};

export default PrivateRoute;
